module.exports = __webpack_public_path__ + "img/share_bg.9def8e05.png";